import { IModel, Model, ModelRecord } from './Model';

export interface IMedicationTypeModel extends IModel {
  medicationTypeId: number;
  name: string;
}

export class MedicationTypeModel
  extends Model
  implements ModelRecord<IMedicationTypeModel>
{
  medicationTypeId: number;
  name: string;

  constructor(params?: Partial<IMedicationTypeModel>) {
    super(params);

    this.medicationTypeId = _.defaultTo(params?.medicationTypeId, 0);
    this.name = _.defaultTo(params?.name, '');
  }
}
